export const ds_QuoteBlock_Entry = `
    fragment ds_QuoteBlock_Entry on ds_QuoteBlock_Entry {
        id
        canonicalUid

        quote_ColorPalette
        quote_ColorTheme
        quote_TopSpacing
        quote_ContainerWidth
        quote_FullWidthBackground

        quote_TextSize
        quote_Alignment

        quote_QuoteItems {
            ... on ds_QuoteItem_Entry {
                quoteItem_Text
                quoteItem_Image {
                    url @transform(width: 48, height: 48)
                    id
                    focalPoint
                }
                quoteItem_Graphic
                quoteItem_AuthorName
                quoteItem_AuthorDetail
                quoteItem_Icon {
                    set
                    name
                    type
                }
            }
        }
    }
`
